import { Injectable, inject, signal, computed } from '@angular/core';
import { ApiService } from '../core/api.service';
import { environment } from '../../environments/environment';
import { ApiKey } from './api-keys.model';

@Injectable({
  providedIn: 'root'
})
export class ApiKeyService {

  private api = inject(ApiService);
  private urlPath = `${environment.api.url}/ui/private/api-key`;

  apiKeys = signal<ApiKey[]>([]);

  hasTigerBroker = computed(() =>
    this.apiKeys().some(key => key.broker === 'tiger-trade')
  );

  hasBybitKey = computed(() =>
    this.apiKeys().some(key => key.market === 'bybit' && !key.broker)
  );

  hasOkxKey = computed(() =>
    this.apiKeys().some(key => key.market === 'okx' && !key.broker)
  );

  hasBinanceKey = computed(() =>
    this.apiKeys().some(key => key.market === 'binance' && !key.broker)
  );

  hasPropBrokerKey = computed(() =>
    this.apiKeys().some(key => key.market === 'propBroker')
  );

  hasPrivodKey = computed(() =>
    this.apiKeys().some(key => key.market === 'privod')
  );

  getAccountKeys() {
    return this.api.get<ApiKey[]>(`${this.urlPath}/get-keys`);
  }

  loadAccountKeys() {
    return this.getAccountKeys().subscribe(data => {
      this.apiKeys.set(data);
    });
  }

}
